import {StyleSheet, Dimensions} from 'react-native';
import SkillzStyle from 'SkillzStyle';

const {fontSizeH3, fontPrimary} = SkillzStyle.fullStyles;
const screenWidth = Dimensions.get('window').width;

export default StyleSheet.create({
  wrapper: {
    // Wrapper will be positioned dynamically via inline styles
  },
  container: {
    backgroundColor: '#d8be81',
    borderColor: '#64341d',
    borderWidth: 3,
    borderRadius: 16,
    padding: 20,
    flexDirection: 'column',
    alignItems: 'flex-end',
    justifyContent: 'center',
    gap: 12,
    maxWidth: screenWidth * 0.7, // Limit to 70% of screen width
    minWidth: 289, // Minimum width from Figma
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 54,
    },
    shadowOpacity: 0.33,
    shadowRadius: 80,
    elevation: 10,
  },
  textContainer: {
    alignSelf: 'stretch',
    gap: 12,
  },
  welcomeText: {
    ...fontPrimary,
    fontSize: 18,
    fontWeight: 'bold',
    color: '#64341d',
    lineHeight: 22,
    letterSpacing: -0.54,
    textAlign: 'left',
  },
  tooltipText: {
    ...fontPrimary,
    fontSize: 16,
    fontWeight: '600',
    color: '#64341d',
    lineHeight: 22,
    letterSpacing: -0.48,
    textAlign: 'left',
  },
  nextButton: {
    backgroundColor: '#ffee7c',
    borderRadius: 16,
    paddingHorizontal: 9,
    paddingVertical: 7,
    height: 41,
    width: 84,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    shadowColor: '#935619',
    shadowOffset: {
      width: 0,
      height: 4,
    },
    shadowOpacity: 1,
    shadowRadius: 0,
    elevation: 4,
  },
  nextButtonContent: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 8,
    flex: 1,
  },
  nextButtonText: {
    fontSize: 16,
    fontWeight: '800',
    color: '#663502',
    textAlign: 'center',
    lineHeight: 25.152,
    fontFamily: 'Inter',
  },
  nextButtonInnerShadow: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    borderRadius: 16,
    // Note: Inner shadows are complex in React Native, using border as approximation
    borderTopColor: '#fff2b6',
    borderTopWidth: 1,
    borderBottomColor: '#b97846',
    borderBottomWidth: 1,
  },
  handImage: {
    width: 61,
    height: 127,
    resizeMode: 'contain',
    // For emoji testing - center the emoji
    textAlign: 'center',
    lineHeight: 60, // Center vertically
  },
  handPointer: {
    position: 'absolute',
    top: (75.57 / 100) * 127, // Convert percentage to actual position
    left: (25.84 / 100) * 61,
    width: (48.64 / 100) * 61, // Convert percentage to actual size
    height: (7.6 / 100) * 127,
    tintColor: '#000',
    opacity: 0.6,
  },
});
